(function(doc, win) {
  const docEl = doc.documentElement,
    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
    recalc = function() {
      let clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      // 限制最大宽度为750px
      if (clientWidth > 750) {
        clientWidth = 750;
      }
      docEl.style.fontSize = clientWidth / 7.5 + "px";
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
})(document, window);
